import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { IconButton, Typography, Box } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import DialogWindow from '../../components/DialogWindow'

const DialogOfferUnavailable = ({ showAlert, setShowAlert, dialogTitle, locale }) => {
    const { t, i18n } = useTranslation()
    const navigate = useNavigate()

    useEffect(() => {
        i18n.changeLanguage(locale)
    }, [locale])

    const handleClickAllOffers = () => {
        navigate(
            window.location.href.includes('/en')
                ? '/en/car-for-company/flexible-rental/'
                : '/auto-dla-firmy/wynajem-elastyczny/'
        )
    }

    return (
        <DialogWindow isOpen={showAlert} setIsOpen={setShowAlert} dialogTitle={dialogTitle}>
            <IconButton
                aria-label="close"
                onClick={() => setShowAlert(false)}
                sx={{
                    position: 'absolute',
                    right: 8,
                    top: 8,
                    color: theme => theme.palette.grey[500],
                }}
            >
                <CloseIcon />
            </IconButton>

            <Typography
                variant="h3"
                fontSize={{ xs: '18px', md: '24px' }}
                fontWeight="bold"
                color={'rgba(0,0,0,0.7)'}
                mb={2}
                textAlign="center"
            >
                {t('errors.error_offer_is_no_longer_available')}
            </Typography>

            <Box textAlign="center">
                <button className="btn-link" onClick={handleClickAllOffers}>
                    {t('btn.see_all')}
                </button>
            </Box>
        </DialogWindow>
    )
}

export default DialogOfferUnavailable
